export const initRegionalContacts = (gateway) => {
  const select = gateway.querySelector('[data-regions-select]');
  const container = gateway.querySelector('[data-region-panels]');
  const panels = [...gateway.querySelectorAll('[data-region-panel]')];
  if (!select || !container) {
    return;
  }

  const update = () => {
    const key = select.selectedOptions[0]?.dataset.region || '';
    panels.forEach((panel) => {
      panel.hidden = panel.dataset.regionPanel !== key;
    });
    container.hidden = !key;
    gateway.classList.toggle('has-region', Boolean(key));
  };

  select.addEventListener('change', update);
  if (gateway.hasAttribute('data-regions-inline')) {
    gateway.querySelector('[data-regions-search]')?.addEventListener('submit', (event) => {
      event.preventDefault();
      update();
    });
  }
  update();
};
